module.exports = __webpack_public_path__ + "static/media/manu-6.d4e3b2d2.png";